export default {
  "group1": {
    color: "#1871f8",
    title: "18-25"
  },
  "group2": {
    color: "#fb614d",
    title: "26-40"
  },
  "group3": {
    color: "#c147ec",
    title: "40+"
  },
  "group4": {
    color: "#5e6d82",
    title: "неизвестно"
  }
}
